export const PopUp = {
  exit: { y: 0, opacity: 1 },
  enter: {
    y: 30,
    opacity: 0,
    transition: { duration: 0.1 },
  },
};
